import React from 'react';
import { AnswerSpeak } from '@ovos-media/templates/dist/sp';

export default ({ props }) => (
  <AnswerSpeak
    {...props}
  />
);